// 7 NPAC Regions
export class Regions {
  public static regions: { id: string, label: string }[] = [
    { id: 'midwest', label: 'Midwest' },
    { id: 'mid-atlantic', label: 'Mid-Atlantic' },
    { id: 'northeast', label: 'Northeast' },
    { id: 'southeast', label: 'Southeast' },
    { id: 'southwest', label: 'Southwest' },
    { id: 'western', label: 'Western' },
    { id: 'west-coast', label: 'West Coast' }
  ];
}
